export const ErrorMessage = {
    INVALID_REQUEST_PARAMETERS: '參數不正確或找不到正確頁面資料',
    REQUIRED: '此欄位為必填',
    INVALID_EMAIL: 'Email 格式錯誤',
    PASSWORD_TOO_SHORT: '密碼長度至少 8 碼',
    UNKNOWN: '發生未知錯誤，請稍後再試',
};